import $ from "jquery";

$(".menu-toggler").click(function () {
	$(this).toggleClass("menu-toggler--opened");
	$(".site-header__container-nav").toggleClass("menu--opened");
});

// au survol sur ('.header__nav > .menu-item'), rendre ('site-header__container-overlay') visible (ajout classe CSS)
document.addEventListener('DOMContentLoaded', () => {
    const menuItems = document.querySelectorAll('.header__nav > .menu-item.menu-item-has-children');
    const overlay = document.querySelector('.site-header__container-overlay');

    menuItems.forEach(item => {
        item.addEventListener('mouseenter', () => {
            overlay.classList.add('overlay-opened');
        });

        item.addEventListener('mouseleave', () => {
            overlay.classList.remove('overlay-opened');
        });
    });
});

const mq = window.matchMedia('(max-width: 1023px)');

function initMobileMenu() {
	// éviter doublons
	if (!$("#main-menu .toggle-sub-menu").length) {
		$("#main-menu .menu-item-has-children")
			.append('<button class="toggle-sub-menu"></button>');
	}

	// handler bouton
	$("#main-menu").on("click", ".toggle-sub-menu", function () {
		$(this).parent().toggleClass("menu-item--opened");
	});

	// handler lien #
	$("#main-menu").on("click", 'a[href="#"]', function (e) {
		e.preventDefault();

		const $btn = $(this).parent().find('.toggle-sub-menu');
		if ($btn.length) {
			$btn.trigger("click");
		}
	});
}

function destroyMobileMenu() {
	// supprimer boutons
	$("#main-menu .toggle-sub-menu").remove();

	// enlever classes ouvertes
	$("#main-menu .menu-item--opened").removeClass("menu-item--opened");

	// retirer events
	$("#main-menu").off("click", ".toggle-sub-menu");
	$("#main-menu").off("click", '.header__nav a[href="#"]');
}

function handleResponsive(e) {
	if (e.matches) {
		initMobileMenu();
	} else {
		destroyMobileMenu();
	}
}

// init au chargement
handleResponsive(mq);

// écoute du resize
mq.addEventListener("change", handleResponsive);